import { useContext, useState } from 'react';

import { getExpressCheckoutMerchantConfig } from '../../../utils/session/getExpressCheckoutMerchantConfig';
import { getMerchantName } from '../../../utils/session/selectors';
import { getStripeExpressCheckoutElementStyleConfig } from '../utils/getStripeExpressCheckoutElementStyleConfig';
import { AppContext } from '../../contextStore/AppContext';
import { CCGThemeProviderContext } from '../../contextStore/CCGThemeProviderContext';

export const useExpressCheckoutWalletManager = () => {
  const [
    expressCheckoutWalletAvailable,
    setExpressCheckoutWalletAvailable,
  ] = useState(false);

  const { originalCheckoutSessionResponse, setData } =
    useContext(AppContext);

  const merchantName = getMerchantName(
    originalCheckoutSessionResponse,
  );

  const { isGooglePayButtonEnabled, isApplePayButtonEnabled } =
    getExpressCheckoutMerchantConfig(
      originalCheckoutSessionResponse,
    );

  const { appearance } = useContext(CCGThemeProviderContext);
  const styleConfig =
    getStripeExpressCheckoutElementStyleConfig(appearance);

  return {
    expressCheckoutWalletAvailable,
    setExpressCheckoutWalletAvailable,
    merchantName,
    isGooglePayButtonEnabled,
    isApplePayButtonEnabled,
    styleConfig,
    appearance,
    originalCheckoutSessionResponse,
    setData,
  };
};
